import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import Button from '@components/ui/Button';
import { Input } from '@components/ui/Input';
import { Label } from '@components/ui/Label';
import { useAuthStore } from '@store/authStore';
import { Alert, AlertDescription } from '@components/ui/Alert';
import { RiAlertLine } from "@remixicon/react";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const { setAuthType } = useAuthStore();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`,
      });

      if (error) throw error;

      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    
    if(!success){
      
      navigate('/');
      setAuthType('signin');
    }else{
      setSuccess(!success);
    }
    
  };

  return (
    <>
     <div className="text-center lg:text-left mb-6"> 
        <h2 className="text-3xl font-bold text-primary-500">{success ? "Recovery link sent" : "Password recovery"}</h2>
      </div>

      {error && (
        <Alert className="border-red-200 bg-red-50 mb-3">
          <RiAlertLine className="h-4 w-4 text-red-600" />
          <AlertDescription className="text-red-800">
            <p>Password recovery failed!</p>
            <p>Please check your email address and try again.</p>
          </AlertDescription>
        </Alert>
      )}

      {success ? (
        <div className="space-y-4">
          <p>
            The password recovery link has been sent to <strong>{email}</strong>.
          </p>
          <p>
            Recovery link will expire in 2 minutes.
          </p>
          <p className="text-sm text-gray-600">
            Open the email and click on the link provided to reset the password. Please check spam folder if it's not going through to your inbox.
          </p>
          <p><a href="#" className="text-primary-500 font-semibold">Resend Recovery Link</a></p>
        </div>
      ) : (
        <div className="space-y-4">
          <p className="text-gray-700">
            Enter your email address to receive a recovery link and reset your password.
          </p>

          <div className="space-y-2">
            <Label htmlFor="email">Email <span className="text-[#0C3E71]"> *</span></Label>
            <Input
              id="email"
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              className="h-11 !bg-white !border-2 !border-border-light !text-slate-500 !rounded-lg"
            />
          </div>
        </div>
      )}

      <div className="flex space-x-4 mt-auto pt-6">

         <Button 
          type="button" 
          variant="secondary"
          mode="stroke"
          className="flex-1 !border-border-light !font-normal"
          onClick={handleCancel}
          disabled={loading}
        >
          {success ? 'Back' : 'Cancel'}
        </Button>

        {!success && 
        <Button 
          type="button"
          className="flex-1 !font-normal bg-primary-500 hover:bg-primary-600 disabled:bg-[#F7F7F7] disabled:border disabled:border-border-light disabled:text-gray-400"
          disabled={loading || !email}
          onClick={handleSubmit}
        >
          {loading ? 'Sending...' : 'Request Link'} 
        </Button>}

      </div>

    {/*
    <div className="welcome-container">
      <div className="welcome-overlay">
        <div className="signin-content">
          <div className="welcome-header">
            <div className="welcome-logo">
              <h1 className="logo-text">TrustJet</h1>
            </div>
            <p className="welcome-tagline">Private skies, verified trust.</p>
          </div>

          <div className="auth-card">
            <h2 className="auth-card-title">Forgot Password</h2>

            {error && <div className="alert alert-error">{error}</div>}

            {success ? (
              <div className="alert alert-success">
                <p>Password reset email sent!</p>
                <p>Please check your email for a link to reset your password.</p>
                <button
                  type="button"
                  onClick={() => navigate('/signin')}
                  className="auth-button auth-button-primary"
                  style={{ marginTop: '1rem' }}
                >
                  Return to Sign In
                </button>
              </div>
            ) : (
              <>
                <p className="auth-description">
                  Enter your email address and we'll send you a link to reset your password.
                </p>

                <form onSubmit={handleSubmit} className="auth-form">
                  <div className="form-group">
                    <label htmlFor="email" className="form-label">
                      Email Address<span className="required-asterisk">*</span>
                    </label>
                    <div className="input-with-icon">
                      <svg className="input-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M3.33301 5.83333L9.99967 10L16.6663 5.83333M3.33301 14.1667H16.6663V5.83333H3.33301V14.1667Z" stroke="#9CA3AF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      <input
                        id="email"
                        type="email"
                        placeholder="example@email.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="auth-input auth-input-with-icon"
                      />
                    </div>
                  </div>

                  <button
                    type="submit"
                    disabled={loading || !email}
                    className="auth-button auth-button-primary"
                  >
                    {loading ? 'Sending...' : 'Send Reset Link'}
                  </button>

                  <button
                    type="button"
                    onClick={handleCancel}
                    className="auth-button auth-button-secondary"
                    disabled={loading}
                  >
                    Cancel
                  </button>
                </form>
              </>
            )}

            <p className="auth-toggle">
              Remember your password?{' '}
              <button type="button" onClick={() => navigate('/signin')}>
                Sign In
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>*/}

    </>
  );
}
